import { render, staticRenderFns } from "./SectionCategoryItem.vue?vue&type=template&id=5c3930d4&scoped=true"
import script from "./SectionCategoryItem.vue?vue&type=script&lang=js"
export * from "./SectionCategoryItem.vue?vue&type=script&lang=js"
import style0 from "./SectionCategoryItem.vue?vue&type=style&index=0&id=5c3930d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3930d4",
  null
  
)

export default component.exports